export default __webpack_public_path__ + "static/media/wall2.d8dbd9ce.jpg";